import { FC } from 'react';
import { Alert, FormInstance, Input } from 'antd';
import ModalAtom, { ModalAtomProps } from 'components/atoms/ModalAtom';
import SpaceAtom from 'components/atoms/SpaceAtom';
import TextButton from 'components/atoms/Button/TextButton';
import PrimaryButton from 'components/atoms/Button/PrimaryButton';
import FormAtom from 'components/atoms/FormAtom';
import { CustomSensorModel } from 'components/pages/AssetPage/Tabs/TabConsumption/OptionList/resources/models';
import { EditSensorFormValues, EditSensorFormValuesNames } from './config';

export interface EditSensorFormModel {
  form: FormInstance<EditSensorFormValues>;
  onFinish: (values: EditSensorFormValues) => void;
  onFinishFailed: () => void;
  loading: boolean;
}

export interface EditSensorOptionsModel {
  sensor: CustomSensorModel | undefined;
  literals: Record<string, string>;
  formOptions: EditSensorFormModel;
  onOpenEditSensorModal: (sensor: CustomSensorModel) => void;
  onCloseEditSensorModal: () => void;
  visible: boolean;
}

interface EditSensorModalProps extends ModalAtomProps {
  options: EditSensorOptionsModel;
  sensor: CustomSensorModel;
}

export const EditSensorModal: FC<EditSensorModalProps> = ({
  options: {
    literals: {
      title,
      secondaryButtonText,
      mainButtonText,
      alertMessage,
      alertDescription,
      nameLabel,
      requiredText,
    },
    formOptions: {
      form,
      onFinish,
      onFinishFailed,
      loading,
    },
  },
  sensor,
  onCancel,
  open,
}) => {
  return (
    <ModalAtom
      open={open}
      title={<SpaceAtom>{title}</SpaceAtom>}
      onCancel={onCancel}
      footer={[
        <TextButton
          key={'back'}
          onClick={onCancel}
          title={secondaryButtonText}
          disabled={loading}
        />,
        <PrimaryButton
          key={'submit'}
          loading={loading}
          htmlType={'submit'}
          title={mainButtonText}
          onClick={() => form.submit()}
        />,
      ]}
      destroyOnClose
    >
      <SpaceAtom direction={'vertical'}>
        <Alert
          message={alertMessage}
          description={alertDescription}
          type={'info'}
          showIcon
        />
        <FormAtom
          form={form}
          className={'SensorTable__form'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          layout={'vertical'}
        >
          <FormAtom.Item
            name={EditSensorFormValuesNames.NAME}
            label={`${nameLabel}:`}
            rules={[{ required: true, message: requiredText, type: 'string' }]}
          >
            <Input placeholder={sensor.name} />
          </FormAtom.Item>
        </FormAtom>
      </SpaceAtom>
    </ModalAtom>
  );
}